import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
  theme,
} from "../../../../utils/styles";

const rahuTransitsStyles = {
  transitBox: {
    borderRadius: "20px",
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    padding: "12px 25px",
    alignItems: "center",
    justifyContent: "end",
    width: "-webkit-fill-available",
  },
  transitHeader: {
    ...regularFont,
    fontSize: getRelativeFontSize(7),
    color: "#ffffff",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(3),
    },
  },
  subHeaderText: {
    ...regularFont,
    fontSize: getRelativeFontSize(10),
    color: "#ffffff",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(6),
    },
  },
  contentText: {
    ...regularFont,
    fontSize: getRelativeFontSize(5),
    color: "#ffffff",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  datePicker: {
    borderRadius: "10px",
    ".MuiOutlinedInput-notchedOutline": { border: "none" },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: "none", // White border on hover
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none", // White border when focused
    },
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 0px 12px 12px",
      color: "#FFFFFF", // Text color
      borderRadius: "10px",
      fontSize: "16px",
      ...mediumFont,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        padding: "10px 0px 10px 12px",
      },
      "&::placeholder": {
        fontSize: "16px",
        ...mediumFont, // Adjust as needed
      },
    },
    "& .MuiOutlinedInput-root": {
      background: "transparent", // Background color
      borderRadius: "10px",
      paddingRight: "15px",
      paddingLeft: "0px",
      border: "1px solid rgba(255, 255, 255, 0.3)", // White border
      "&.Mui-focused fieldset": {
        border: "none", // White border when focused
      },
      [theme.breakpoints.down("sm")]: {
        paddingRight: "25px",
        paddingLeft: "8px",
      },
    },
    // Style for the calendar icon
    "& .MuiSvgIcon-root": {
      color: "#FFFFFF", // White color for the calendar icon
    },
  },
  legendDescText: {
    ...regularFont,
    fontSize: getRelativeFontSize(3),
    color: "#ffffffb8",
    display: "list-item",
    listStyle: "square",
    ml: "10px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
} as const;

export default rahuTransitsStyles;
